<nz-skeleton [nzAvatar]="true"></nz-skeleton>